import { useCallback, useRef, useState } from 'react';

function useModal<D>( initialState?: boolean ) {
  const [showModal, setModal] = useState( initialState || false );
  const selectedItemRef = useRef<D>();

  const toggleModal = useCallback( () => {
    setModal( ( state ) => !state );
  }, [] );

  const openModal = useCallback( ( item?: D ) => {
    toggleModal();
    selectedItemRef.current = item;
  }, [] );

  const closeModal = useCallback( toggleModal, [] );

  return {
    showModal,
    closeModal,
    openModal,
    selectedItem: selectedItemRef.current,
  };
}

export default useModal;
